export default {"src":"/_next/static/media/paperless_company.53154e1b.svg","height":96,"width":96};